import React, { DetailedHTMLProps, PropsWithChildren } from 'react';
import { RegisterOptions } from 'react-hook-form/dist/types/validator';
import { Path, useFormContext } from 'react-hook-form';

import { BaseFromProps } from './BaseFromProps';

export function TextArea<T>({ children, label, name, options, defaultValue, width, ...props }: PropsWithChildren<TextAreaProps<T>>) {
  const {
    register,
    formState: { errors },
  } = useFormContext<T>();
  return (
    <div className={`${width || 'sixteen'} wide column`}>
      <div className="field">
        <div className="ui labeled input">
          <div className="ui label">{label}</div>
          <div className="ui right labeled input">
            <textarea key={name} defaultValue={defaultValue} {...props} {...register(name as Path<T>, options)} />
            {children}
          </div>
        </div>
        {!!errors[name] && <div className="ui pointing red basic label">{errors[name]?.message as string}</div>}
      </div>
    </div>
  );
}

export type TextAreaProps<T> = {
  defaultValue: string;
} & BaseFromProps<T> &
  DetailedHTMLProps<React.InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;
